module.exports = __webpack_public_path__ + "7c6b2aa9c0eda6b05f5fd734ada8f202.MP3";